import {
  QUOTE_SCORE_COMPETITIVE,
  QUOTE_SCORE_COMPETITIVE_TINT,
  QUOTE_SCORE_COMPETITIVE_TINT_HOVER,
  QUOTE_SCORE_MUTED,
  QUOTE_SCORE_MUTED_TINT,
  QUOTE_SCORE_NOT_COMPETITIVE,
  QUOTE_SCORE_NOT_COMPETITIVE_TINT,
  QUOTE_SCORE_NOT_COMPETITIVE_TINT_HOVER,
  QUOTE_SCORE_SOMEWHAT_COMPETITIVE,
  QUOTE_SCORE_SOMEWHAT_COMPETITIVE_TINT,
  QUOTE_SCORE_SOMEWHAT_COMPETITIVE_TINT_HOVER,
  QUOTE_SCORE_VERY_COMPETITIVE,
  QUOTE_SCORE_VERY_COMPETITIVE_TINT,
  QUOTE_SCORE_VERY_COMPETITIVE_TINT_HOVER,
} from "constants/index";

export interface QuoteScoreLevelStyle {
  label: string;
  color: string;
  // Faint background for the collapsed bar.
  tint: string;
  // One step deeper, used on hover so the bar reads as a control.
  hoverTint: string;
}

export const QUOTE_SCORE_LEVEL_STYLES: Record<
  QuoteScoreLevel,
  QuoteScoreLevelStyle
> = {
  very_competitive: {
    label: "Very competitive",
    color: QUOTE_SCORE_VERY_COMPETITIVE,
    tint: QUOTE_SCORE_VERY_COMPETITIVE_TINT,
    hoverTint: QUOTE_SCORE_VERY_COMPETITIVE_TINT_HOVER,
  },
  competitive: {
    label: "Competitive",
    color: QUOTE_SCORE_COMPETITIVE,
    tint: QUOTE_SCORE_COMPETITIVE_TINT,
    hoverTint: QUOTE_SCORE_COMPETITIVE_TINT_HOVER,
  },
  somewhat_competitive: {
    label: "Somewhat competitive",
    color: QUOTE_SCORE_SOMEWHAT_COMPETITIVE,
    tint: QUOTE_SCORE_SOMEWHAT_COMPETITIVE_TINT,
    hoverTint: QUOTE_SCORE_SOMEWHAT_COMPETITIVE_TINT_HOVER,
  },
  not_competitive: {
    label: "Not competitive",
    color: QUOTE_SCORE_NOT_COMPETITIVE,
    tint: QUOTE_SCORE_NOT_COMPETITIVE_TINT,
    hoverTint: QUOTE_SCORE_NOT_COMPETITIVE_TINT_HOVER,
  },
};

// Terminal quotes (declined / expired / cancelled / lost) drop to grey so
// attention flows to the quotes that can still be acted on.
export const QUOTE_SCORE_MUTED_STYLE: QuoteScoreLevelStyle = {
  label: "",
  color: QUOTE_SCORE_MUTED,
  tint: QUOTE_SCORE_MUTED_TINT,
  hoverTint: QUOTE_SCORE_MUTED_TINT,
};

export function getQuoteScoreLevelStyle(
  level: QuoteScoreLevel,
): QuoteScoreLevelStyle {
  return QUOTE_SCORE_LEVEL_STYLES[level];
}
